/** Rolling timing samples (ms) for profiling the match loop; exposed via the `?debug` hook. */
export class FrameStats {
	private readonly sim: number[] = [];
	private readonly view: number[] = [];

	constructor(private readonly capacity = 240) {}

	record(simMs: number, viewMs: number): void {
		push(this.sim, simMs, this.capacity);
		push(this.view, viewMs, this.capacity);
	}

	summary() {
		return { sim: describe(this.sim), view: describe(this.view), frames: this.sim.length };
	}

	reset(): void {
		this.sim.length = 0;
		this.view.length = 0;
	}
}

function push(list: number[], value: number, capacity: number): void {
	list.push(value);
	if (list.length > capacity) list.shift();
}

export function describe(samples: readonly number[]) {
	if (samples.length === 0) return { avg: 0, p95: 0, max: 0 };
	const sorted = [...samples].sort((a, b) => a - b);
	const avg = samples.reduce((a, b) => a + b, 0) / samples.length;
	const p95 = sorted[Math.min(sorted.length - 1, Math.floor(sorted.length * 0.95))] ?? 0;
	return { avg, p95, max: sorted[sorted.length - 1] ?? 0 };
}
